"use client"

import { useEffect, useState } from "react"
import { ACTIVE_APP_ENVIRONMENT, APP_ENVIRONMENTS } from "@/lib/appEnvironment"
import { isNativeApp } from "@/lib/platform"
import { AppEnvironmentSettings } from "./AppEnvironmentSettings"

export function AppEnvironmentFooter() {
  const [native, setNative] = useState(false)
  useEffect(() => setNative(isNativeApp()), [])
  if (!native) return null

  return (
    <div className="mt-2 text-center">
      <p className="text-xs text-muted-foreground">Ambiente: <span className="font-semibold">{APP_ENVIRONMENTS[ACTIVE_APP_ENVIRONMENT].label}</span></p>
      <AppEnvironmentSettings />
    </div>
  )
}
